
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import { Home } from '../pages/Home';
import { Legal } from '../pages/Legal/Legal';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Home />} />
      <Route
          path="/privacy"
          element={<Legal page="privacy" />}
      />
      <Route
          path="/cookies"
          element={<Legal page="cookies" />}
      />
      <Route
          path="/terms"
          element={<Legal page="terms" />}
      />
    </Routes>
    </BrowserRouter>
  );
}

export default App;
